module.exports = __webpack_public_path__ + "img/icon_sb_unselect_star_reviews_i_t.5dbb1fa.svg";